/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');
const logger = require('@gral/log');

// -=======================================================
// ## Private
// -=======================================================
let _viewCnt = 0;

// -=======================================================
// ## Public
// -=======================================================
module.exports = {
  UNSAFE_componentWillMount() {
    let left;
    this.compId = (left = this.props.model != null ? this.props.model.get('cid') : undefined) != null ? left : _viewCnt++;
    return (this.log = logger(`COMP ${this.constructor.displayName} ${this.compId}`));
  },

  cancelEvent(ev) {
    ev.preventDefault();
    return ev.stopPropagation();
  },
};
